export default __webpack_public_path__ + "static/media/jumbotron_list.f8d2501f.png";